import { gql } from '@apollo/client';

export const getYearCleaningReportStatistics = gql`
  query getYearCleaningReportStatistics($machineId: ID!) {
    getYearCleaningReportStatistics(machineId: $machineId) {
      name
      isoYear
      isoMonth
      currentStatistics {
        cleanedSquareMeter
        hours
      }
      maxStatistics {
        cleanedSquareMeter
        hours
      }
    }
  }
`;

export const getPast6MonthsCleaningReportStatistics = gql`
  query getPast6MonthsCleaningReportStatistics($machineId: ID!) {
    getPast6MonthsCleaningReportStatistics(machineId: $machineId) {
      name
      isoYear
      isoMonth
      currentStatistics {
        cleanedSquareMeter
        hours
      }
      maxStatistics {
        cleanedSquareMeter
        hours
      }
    }
  }
`;

export const getTotalCleaningReportStatistics = gql`
  query getTotalCleaningReportStatistics($machineId: ID!, $groupBy: String) {
    getTotalCleaningReportStatistics(machineId: $machineId, groupBy: $groupBy) {
      cleanedSquareMeter
      hours
    }
  }
`;

export const getMonthCleaningReportStatistics = gql`
  query getMonthCleaningReportStatistics($machineId: ID!) {
    getMonthCleaningReportStatistics(machineId: $machineId) {
      name
      isoYear
      isoMonth
      isoWeek
      startDateOfWeek
      endDateOfWeek
      currentStatistics {
        cleanedSquareMeter
        hours
      }
      maxStatistics {
        cleanedSquareMeter
        hours
      }
    }
  }
`;

export const getWeekCleaningReportStatistics = gql`
  query getWeekCleaningReportStatistics($machineId: ID!) {
    getWeekCleaningReportStatistics(machineId: $machineId) {
      name
      isoYear
      isoWeek
      isoDay
      date
      currentStatistics {
        cleanedSquareMeter
        hours
      }
      maxStatistics {
        cleanedSquareMeter
        hours
      }
    }
  }
`;
